"use client";

import React from "react";
import { Car, HeartPulse, Shield, Ship, Flame, Building2, Scale, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const portfolioItems = [{
  id: "creative-finance",
  title: "Creative Finance",
  description: "Building wealth in non-traditional formats using our unique three-dimensional outlook on modern assets.",
  icon: Flame,
  link: "/CreativeWealthPage"
}, {
  id: "living-benefits",
  title: "Living Benefits",
  description: "Accelerated Death Benefit riders that allow you to use your protection today for critical health events.",
  icon: HeartPulse,
  link: "/LifeInsurancePage"
}, {
  id: "hybrid-annuities",
  title: "Hybrid Annuities",
  description: "Create a self-made pension with lifetime guaranteed income and robust protection against market downsides.",
  icon: Shield,
  link: "/CreativeWealthPage"
}, {
  id: "financial-literacy",
  title: "Financial Literacy",
  description: "Mastering the mechanics of wealth while debunking common myths and financial misconceptions.",
  icon: Scale,
  link: "/HomePage"
}, {
  id: "asset-legacy",
  title: "Asset Transition",
  description: "Sophisticated strategies for converting 401Ks or Roth IRAs into permanent, lifetime income sources.",
  icon: Ship,
  link: "/CreativeWealthPage"
}, {
  id: "wealth-protection",
  title: "Wealth Protection",
  description: "Bespoke life insurance plans designed to secure your loved ones' future and replace lost income.",
  icon: Building2,
  link: "/LifeInsurancePage"
}, {
  id: "pension-planning",
  title: "Pension Planning",
  description: "Securing your retirement transit with bonuses and guaranteed growth in a scarce pension world.",
  icon: Car,
  link: "/CreativeWealthPage"
}, {
  id: "secure-future",
  title: "Secure Future",
  description: "Defend your financial legacy with non-traditional means that offer flexibility and peace of mind.",
  icon: Lock,
  link: "/CreativeWealthPage"
}];
export default function OurProtectionPortfolio() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="96999" id="core-wealth-strategies" className="py-24 bg-background dark text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" />
      
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[40rem] font-serif font-bold text-primary/[0.03] pointer-events-none select-none">
        W
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        
        {}
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 space-y-4 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="outline" className="text-accent border-accent/20 bg-accent/5 px-4 py-1.5 text-xs font-mono tracking-widest uppercase rounded-full">
            The Alchemist's Ledger
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold font-serif tracking-tight text-foreground">
            Core Wealth Strategies
          </h2>
          <p className="text-muted-foreground max-w-2xl text-lg md:text-xl font-sans leading-relaxed">
            Innovative financial architecture designed to build, protect, and transition your legacy through non-traditional means.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {portfolioItems.map((item, i) => {
          const Icon = item.icon;
          return <Card key={item.id} data-index={i} className={`group relative overflow-hidden border-white/10 shadow-lg hover:shadow-primary/10 hover:border-primary/40 transition-all duration-500 flex flex-col h-full p-8 rounded-2xl bg-white/5 backdrop-blur-md cursor-pointer ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                {}
                <div className="mb-6 text-primary drop-shadow-[0_0_15px_rgba(234,179,8,0.3)] transition-transform duration-500 ease-out group-hover:scale-110 origin-left">
                  <Icon className="w-14 h-14 stroke-[1.25]" />
                </div>

                {}
                <div className="flex-grow flex flex-col relative z-10">
                  <h3 className="text-xl font-bold font-serif text-foreground mb-3 group-hover:text-primary transition-colors duration-300">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-6 font-sans">
                    {item.description}
                  </p>
                </div>

                {}
                <div className="mt-auto pt-2 relative z-10">
                  <div className="h-11 relative overflow-hidden rounded-md">
                    <Button asChild variant="secondary" className="w-full h-full absolute inset-0 transform translate-y-full group-hover:translate-y-0 transition-transform duration-400 ease-out bg-primary hover:bg-primary/90 text-primary-foreground font-bold tracking-tight shadow-xl">
                      <Link to={item.link}>
                        Learn More <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
                      </Link>
                    </Button>
                  </div>
                </div>
              </Card>;
        })}
        </div>

      </div>
    </section>;
}